import { observer } from "mobx-react";
import { WhatsappIcon } from "react-share";
import logo_black from "../../assets/images/logoBlackBig.png";
import veehiveText_black from "../../assets/images/text_black.png";

const Footer = () => {
  return (
    <div className="mt-5">
      <footer className="text-sm text-gray-400 flex items-center space-x-2">
        <a href="https://www.veehive.ai" target="_blank" rel="noreferrer">
          <div className="flex items-center">
            <img src={logo_black} alt="Logo" className="w-12" />
            {/* <img src={veehiveText_black} className="w-10 ml-1" alt="" /> */}
          </div>
        </a>
        <div className="">|</div>
        <div className="flex">
          <a
            href="https://veehive.ai/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            <div className="hover:underline text-gray-500">Privacy Policy</div>
          </a>
          <div className="px-1">|</div>
          <a
            href="https://veehive.ai/terms-and-conditions"
            target="_blank"
            rel="noreferrer"
          >
            <div className="hover:underline text-gray-500">
              Terms of Services
            </div>
          </a>
        </div>
        <div className="">|</div>
        <div>
          <ul className="flex flex-wrap text-center space-x-4 sm:space-x-8">
            <div className="flex flex-col md:flex-row items-center">
              <a
                href="https://wa.me/+917019375343"
                target="_blank"
                rel="noreferrer"
              >
                <div className="mr-1 flex items-center">
                  <WhatsappIcon round className="h-5 w-5" />
                </div>
              </a>
            </div>
          </ul>
        </div>
      </footer>
    </div>
  );
};

export default observer(Footer);
